<template>
  <div class="DataTables DeriveSearchedPartFormComponent ">

    <p><span v-if="isAll"><b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{lang.infotext_3}}</span></p>
    <p><span v-if="isCisCompatible == true"><b-spinner small label="alert" type="grow" variant="warning"></b-spinner> {{lang.infotext_4}}</span></p>
    <span v-if="!isAll">
      <p>{{lang.infotext_1}}: {{categoryName}}</p>
      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <div :id="id"></div>
      <p><b-badge class="badge badge-blue badge">Request</b-badge> - {{lang.infotext_2}}</p>
    </span>
  </div>
</template>
<script>
  import PartPropertiesType from '@/constants/PartPropertiesType'
  import LoaderComponent from "@/components/shared/LoaderComponent"


    export default {
        name: "DeriveSearchedPartFormComponent",
        props:{
          lang: Object
        },
        components: {

          LoaderComponent
        },
        data () {
          return {

            mainTable: "",
            id: "DeriveSearchedPartFormComponent",
            properties: [],
            foundPartDatas: [],
            fullListPropsFound: [],
            isData: false
          }
        },
        computed: {
          isCisCompatible(){
            return this.$store.getters.selectedTreeItemObject.depth == 2 && this.$store.getters.selectedTreeItemObject.cisCompatible == true;
          },
          isAll(){
            if (this.$store.getters.selectedTreeItemObject.category == "All components"){
              return true;
            }
            return false;
          },
          // isData(){
          //   return this.fullListPropsFound.length != 0;
          // },
          categoryId(){
            return this.$store.getters.selectedTreeItemObject.categoryId;
          },
          categoryName(){
            return this.$store.getters.selectedTreeItemObject.category;
          },
          selectedSearchedRows(){
            return this.$store.getters.selectedSearchedRows;
          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }
        },
        created () {
          

          this.getproperties();

        },
        watch: {
          categoryId: function(){

            this.getproperties();
          },
          // isData: function(){
            
          //   this.getproperties();
          // }

        },
        updated() {

        },
        mounted: function () {

        },
        methods: {
          getproperties(){

            let vue = this;
            vue.properties = [];
            this.isData = false;

            const obj = {
              categoryId: this.categoryId

            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProperties", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK") {

                if (result.data != null) {
                  vue.isData = true;

                  for (let i = 0, lei = result.data.length; i < lei; i++) {

                    if (result.data[i].type != "part number") {

                      vue.properties.push(result.data[i]);
                    }
                  }
                }
                
                //vue.properties = result.data;



                vue.getDataDetails();
              }

            })

          },
          getDataDetails(){

            let vue = this;

            const obj = {
              distributorPartId: this.selectedSearchedRows.DistributorPartId

            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchedPartsDetails", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){

                vue.foundPartDatas = result.data;



                vue.buildFullPropsListFound();
              }

            })

          },
          buildFullPropsListFound(){


            this.fullListPropsFound = [];

            for (let el in this.selectedSearchedRows) {
              let s = this.selectedSearchedRows[el];
              if (s == null) {
                s = "";
              } else {
                
              }
              const obj = {
                name: el,
                value: s
              }

              this.fullListPropsFound.push(obj);
            }

            for (let i = 0, lei = this.foundPartDatas.Properties.length; i < lei; i++){
              let value = "";
              if (this.foundPartDatas.Properties[i].Type == "singleValue"){

                if (this.foundPartDatas.Properties[i].Values != null){
                  value = this.foundPartDatas.Properties[i].Values;
                }

              }else{
                try{
                  value = this.foundPartDatas.Properties[i].Values[0];
                }catch(ex){
                  console.log(ex);

                }

              }
              const obj = {
                name: this.foundPartDatas.Properties[i].Name,
                value: value
              }

              this.fullListPropsFound.push(obj);
            }




            this.buildTable();

          },
          validateValues(obj) {
            
            let vue = this;

            let arr = [obj];

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewPartValidation", arr)
              .then((result) => {

                //console.log(result);

                if (result.status == "OK") {
                  if (result.data.valid == false) {


                    for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                      vue.displayValidationRules(result.data.violatedRules[i])
                    }
                  } else {
                    vue.resetValidationRules(obj);
                  }
                }



              })


          },
          displayValidationRules(obj) {

            let id = "value__" + obj.propertyId;
            let elem = document.getElementById(id);
            elem.classList.add("warning");

            let idInvalidFeedback = id + "__invalid";
            let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
            elemInvalidFeedback.setAttribute("style", "display: block");
            elemInvalidFeedback.innerHTML = obj.message;

          },
          resetValidationRules(obj) {

            let id = "value__" + obj.propertyId;
            let elem = document.getElementById(id);
            elem.classList.remove("warning");

            let idInvalidFeedback = id + "__invalid";
            let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
            elemInvalidFeedback.setAttribute("style", "display: none");
            elemInvalidFeedback.innerHTML = "";
          },
          checkFormValidationAfterLoad() {


            let editParts = document.getElementsByClassName('new-part');

            for (var i = 0; i < editParts.length; i++) {

              let temp = editParts[i].id.split("__")

              const validObj = {
                propertyId: temp[1],
                value: editParts[i].value,
              }
              this.validateValues(validObj);


            }

          },
          buildTable(){
            

//todo check mapping, wrong solution here:

            this.$store.dispatch("resetPropertyToSaving");

            for (let i = 0, lei = this.properties.length; i < lei; i++){
              let value = "";
              for (let j = 0, lej = this.fullListPropsFound.length; j < lej; j++){
                let trig = false;

                if (this.fullListPropsFound[j].name.toLowerCase() == this.properties[i].name.toLowerCase()){

                  trig = true;

                }
                if (!trig){
                  let temp = this.fullListPropsFound[j].name.toLowerCase().replace(" ", "_");

                  if (temp == this.properties[i].name.toLowerCase()){
                    trig = true;

                  }
                }
                if (!trig){
                  let temp = this.fullListPropsFound[j].name.toLowerCase().replace("_", " ");

                  if (temp == this.properties[i].name.toLowerCase()){
                    trig = true;

                  }
                }
                if (!trig){
                  let temp = this.properties[i].name.toLowerCase().replace(" ", "_");

                  if (temp == this.fullListPropsFound[j].name.toLowerCase()){
                    trig = true;

                  }
                }
                if (!trig){
                  let temp = this.properties[i].name.toLowerCase().replace("_", " ");

                  if (temp == this.fullListPropsFound[j].name.toLowerCase()){
                    trig = true;

                  }
                }
                if (!trig){
                  let temp = this.properties[i].name.toLowerCase().indexOf(this.fullListPropsFound[j].name.toLowerCase());

                  if (temp > -1){
                    trig = true;

                  }
                }
                if (!trig){
                  let temp = this.fullListPropsFound[j].name.toLowerCase().indexOf(this.properties[i].name.toLowerCase());

                  if (temp > -1){
                    trig = true;

                  }
                }

                if (trig){
                  this.properties[i].value = this.fullListPropsFound[j].value;
                  this.properties[i].selected = this.fullListPropsFound[j].name;

                  const obj = {
                    propertyId: this.properties[i].propertyId,
                    value: this.fullListPropsFound[j].value,
                    type: this.properties[i].type,
                    isRequiredOnRequest: this.properties[i].isRequiredOnRequest
                  }
                  this.$store.dispatch("addPropertyToSaving", obj);

                  break;
                }else{
                  this.properties[i].value = "";
                  this.properties[i].selected = "";

                  const obj = {
                    propertyId: this.properties[i].propertyId,
                    value: "",
                    type: this.properties[i].type,
                    isRequiredOnRequest: this.properties[i].isRequiredOnRequest
                  }
                  this.$store.dispatch("addPropertyToSaving", obj);
                }


              }

            }

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
              return;
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");

            var thead = document.createElement("thead");
            thead.appendChild(tr);

            table.appendChild(thead);

            let vue = this;


            let cols =  [
              { "data": "propertyId" },
              { "data": "priority" },
              { "data": "name" },
              { "data": "value" },
              { "data": "found" },
            ]

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: "Priority",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Name,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Value,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Found,
                alignInColumn: "left",

              },



            ]




            var columnDefs = [];

            for (var i = 0, len = columns.length; i < len; i++){

              let classname = '_dt-body-'+ columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {
                    if (data == null) {
                      data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                      data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 2){
                      let required = "<span class=\"required\">";
                      
                        if (row.isRequiredOnRequest == true){
                          required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                        }
                        
                        required += "</span>"
                      
                      return data + "   " + required;
                    }
                    if (meta.col == 3){
                      // let prepend = "";
                      // if (row.isRequiredOnRequest == true){
                      //   prepend += "<div class=\"input-group-prepend  outline-warning prepend-new-part\">";
                      //   prepend += "<div class=\"input-group-text\">*</div>";
                      //   prepend += "</div>";
                      // }
                      
                      if (row.type == "image"){
                        //if (data.display == ""){
                          let src = "/static/" + vue.$store.getters.selectedTreeItemObject.category + "/img.png";
                        //}

                        let img = "<img src=\"" + src + "\" class=\"img-thumbnail img-fluid\"><br><br>";
                        img += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        img += "<div class=\"custom-file b-form-file import-file b-custom-control-sm\">";
                        img += "";
                        img += "<input data-type=\""+row.type+"\" id=\"file__"+row.propertyId +"__" + row.isRequiredOnRequest + "\" class=\"custom-file-input is-invalid\" type=\"file\">";
                        img += "<label class=\"custom-file-label\" data-browse=\"Browse\">";
                        img += "<span class=\"d-block form-file-text\">Choose a image</span>";
                        img += "</label>";
                        img += "</div>";
                        img += "</div>";
                        return img;
                      }else if (row.type == "text"){

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;
                      }else if (row.type == "value"){

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;  
                      
                      }else if (row.type == "rohs"){

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;  

                      } else if (row.type == PartPropertiesType.PART || row.type == PartPropertiesType.SYMBOL){
                        let str = "<div role=\"group\" class=\"input-group\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\"></input>";
                        str += "<div class=\"input-group-append\">";
                        str += "<button  data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"btn btn btn-secondary btn-"+vue.variant+" btn-sm form-control-sm button_action_symbol\" id=\"symbolId__" + row.propertyId +"__" + row.isRequiredOnRequest +"\" >"+vue.lang.button_Symbol+"</button>";

                        str += "</div></div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;

                      } else if (row.type == PartPropertiesType.HDLSYMBOL) {
                        let str = "<div role=\"group\" class=\"input-group\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\"></input>";
                        str += "<div class=\"input-group-append\">";
                        str += "<button  data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"btn btn btn-secondary btn-" + vue.variant + " btn-sm form-control-sm button_action_symbol\" id=\"symbolId__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" >" + vue.lang.button_Symbol + "</button>";

                        str += "</div></div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;
                        
                      } else if (row.type == PartPropertiesType.FOOTPRINT){
                        let str = "<div role=\"group\" class=\"input-group\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\"></input>";
                        str += "<div class=\"input-group-append\">";
                          str += "<button  data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"btn btn btn-secondary  btn-"+vue.variant+" btn-sm form-control-sm button_action_footprint\" id=\"footprintId__" + row.propertyId +"__" + row.isRequiredOnRequest +"\" >"+vue.lang.button_Footprint+"</button>";
                          
                        str += "</div></div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;

                        } else if (row.type == "library") {
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button  data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"btn btn btn-secondary  btn-" + vue.variant + " btn-sm form-control-sm button-action-library\" id=\"footprintId__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" >" + vue.lang.button_Footprint + "</button>";

                          str += "</div></div>";
                          str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                          return str;
                      }else if (row.type == "link"){
                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;

                      }else if (row.type == "part number"){
                        let pn = "";

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\""+row.type+"\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div><small id=\"input-live-help\" class=\"form-text text-muted\">" + vue.lang.label_PartNumber + "</small>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                        return str;
                      } else if (row.type == "pack type") {
                        let pn = "";

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;
                      } else if (row.type == "description") {
                        let pn = "";

                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;
                      }else if (row.type == "type"){
                        let str = "<select data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part type-select\" id=\"value__" + row.propertyId + "\">";

                          const tab = ["Electric", "Mechanical", "Software"];
                          for (let j = 0, lej = tab.length; j < lej; j++){

                            let selected = "";
                            if (tab[j] == row.value){
                              selected = "selected=\"selected\""
                            }
                            str += "<option value=\""+tab[j]+"\" "+selected+">"+tab[j]+"</option>";
                          }
                          
                        str += "</select>";
                        
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                        const obj = {
                          propertyId: row.propertyId,
                          value: "Electric",
                          type: "type"
                        }

                        vue.$store.dispatch("addPropertyToSaving", obj);

                        return  str;  
                      } else {
                        let str = "";
                        str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                        str += "";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                        return str;
                      }

                    }
                    if (meta.col == 4){
                      if (row.type == "type"){
                        return "";
                      }
                      let elem = "";
                      elem += "<div class=\"select-group\">";
                      elem += "<select id=\"prop__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" class=\"custom-select custom-select-sm select-prop-derive\">";
                      elem += "<option value=\"\"></option>";



                      for (let k = 0, lek = vue.fullListPropsFound.length; k < lek; k++){
                        let selected = "";
                        if (row.selected == vue.fullListPropsFound[k].name){
                          selected = "selected=\"selected\"";
                        }

                        elem += "<option value=\"" + vue.fullListPropsFound[k].value + "\" " + selected + ">" + vue.fullListPropsFound[k].name + " -> " + vue.fullListPropsFound[k].value + "</option>";
                      }

                      elem += "</select>";
                      elem += "</div>";
                      return elem;
                    }


                    return data;
                  }
                }

              columnDefs.push(el);


              var th = document.createElement("th");
              tr.appendChild(th);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(columns[i].name)
              th.appendChild(tx);


            }


            var option = {};
            option.paging = false;
            option.info = false;
            option.dom = 'f<t>';
            option.data= this.properties;
            option.myColumnFormats = columns;
            option.select = false;
            option.columns = cols;
            option.columnDefs = columnDefs;
            option.order = [1, "asc"];
            option.initComplete = function () {

              vue.checkFormValidationAfterLoad();
            }



            if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_'+this.id).DataTable(option);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column(0).visible(false);
            this.mainTable.column(1).visible(false);

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")



            let editParts = document.getElementsByClassName('new-part');

            for (var i = 0; i < editParts.length; i++) {
              editParts[i].addEventListener('input', function (e){

                let temp = this.id.split("__");
                let propertyId = temp[1];
                let type = $(this).attr("data-type");
                let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");
          
                const obj = {
                  propertyId: propertyId,
                  value: this.value,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: this.value,
                }
                vue.validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
              })
            }

            let selectProp = document.getElementsByClassName('select-prop-derive');

            for (var i = 0; i < selectProp.length; i++) {
              selectProp[i].addEventListener('input', function (e){

                let temp = this.id.split("__");
                let propertyId = temp[1];
                let field = document.getElementById("value__" + temp[1] );
                

                field.value = this.value;

                let type = $(this).attr("data-type");
                let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

                const obj = {
                  propertyId: propertyId,
                  value: this.value,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: this.value,
                }
                vue.validateValues(validObj);
          

                vue.$store.dispatch("addPropertyToSaving", obj);

              })
            }

            let symbols_buttons = document.getElementsByClassName('button_action_symbol');

            for (let i = 0, lei = symbols_buttons.length; i < lei; i++) {
              symbols_buttons[i].addEventListener('click', function (e){
                
                let id = this.id;
                let temp = id.split("__");
                let f = document.getElementById("value__" + temp[1] )
                
                let selectedSymbols = f.value;

                let type = f.dataset.type;

                let propertyId = temp[1];
                let isRequiredOnRequest = f.dataset.isRequiredOnRequest;

                let validateValues = vue.validateValues;

                let funcYes = function(vue){

                  let temp = id.split("__");
  
                  let f = document.getElementById("value__" + temp[1] )

                  let str = "";
                  for(let i = 0, lei = vue.$store.getters.selectedSymbols.length; i < lei; i++){
                    str += vue.$store.getters.selectedSymbols[i].name;
                    if (i < lei - 1){
                      str += ", ";
                    }

                  }
                  
                  f.value = str;

                  const obj = {
                    propertyId: propertyId,
                    value: str,
                    type: type,
                    isRequiredOnRequest: isRequiredOnRequest
                  }
                  const validObj = {
                    propertyId: propertyId,
                    value: str,
                  }
                  validateValues(validObj);


                  vue.$store.dispatch("addPropertyToSaving", obj);
                  
                }

                if (type == PartPropertiesType.HDLSYMBOL) {
                  vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleHDL;
                } if (type == PartPropertiesType.PART || type == PartPropertiesType.SYMBOL) {
                  vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleSymbols
                }

                const obj = {
                  title: "",
                  text: "",
                  type: "symbols",
                  selected: selectedSymbols,
                  buttons: 2,
                  size: "lg",
                  lang: vue.lang.modal_Symbols,
                  data: {
                    type: type,
                  },
                  funcNo: "",
                  funcYes: funcYes,
                  
                };
                vue.$store.dispatch("showModalComponent", obj);
              })
            }

            let footprints_buttons = document.getElementsByClassName('button_action_footprint');

            for (let i = 0, lei = footprints_buttons.length; i < lei; i++) {
              footprints_buttons[i].addEventListener('click', function (e){

                              
                let id = this.id;
                let temp = id.split("__");

                let f = document.getElementById("value__" + temp[1] )
                let selectedFootprint = f.value;

                let type = f.dataset.type;

                let propertyId = temp[1];
                let validateValues = vue.validateValues;
                let isRequiredOnRequest = f.dataset.isRequiredOnRequest;

                let funcYes = function(vue){

                  let temp = id.split("__");

                  let f = document.getElementById("value__" + temp[1] )
                  
                  f.value = vue.$store.getters.selectedFootprints[0].name;

                  const obj = {
                    propertyId: propertyId,
                    value: vue.$store.getters.selectedFootprints[0].name,
                    type: type,
                    isRequiredOnRequest: isRequiredOnRequest
                  }
                  const validObj = {
                    propertyId: propertyId,
                    value: vue.$store.getters.selectedFootprints[0].name,
                  }
                  validateValues(validObj);


                  vue.$store.dispatch("addPropertyToSaving", obj);
                  
                }

                const obj = {
                  title: "Footprints",
                  text: "",
                  type: "footprints",
                  selected: selectedFootprint,
                  buttons: 2,
                  size: "lg",
                  lang: vue.lang.modal_Footprints,
                  funcNo: "",
                  funcYes: funcYes,
                  
                };
                vue.$store.dispatch("showModalComponent", obj);
              })
            }

            let library_buttons = document.getElementsByClassName('button-action-library');

            for (let i = 0, lei = library_buttons.length; i < lei; i++) {
              library_buttons[i].addEventListener('click', function (e) {

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteSelectedFootprint");

                let id = this.id;
                let temp = id.split("__");

                let propertyId = temp[1];
                let type = $(this).attr("data-type");
                let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest");

                let f = document.getElementById("value__" + temp[1])
                let selectedFootprint = f.value;

                
                let validateValues = vue.validateValues;
                

                let funcYes = function (vue) {




                  f.value = vue.$store.getters.selectedFootprints[0].name;

                  const obj = {
                    propertyId: propertyId,
                    value: vue.$store.getters.selectedFootprints[0].name,
                    type: "library",
                    isRequiredOnRequest: isRequiredOnRequest
                  }
                  const validObj = {
                    propertyId: propertyId,
                    value: vue.$store.getters.selectedFootprints[0].name,
                  }
                  validateValues(validObj);
                  
                  vue.$store.dispatch("addPropertyToSaving", obj);

                }

                const obj = {
                  title: "Libraries",
                  text: "",
                  type: "libraries",
                  selected: selectedFootprint,
                  data: {
                    propertyId: propertyId
                  },
                  buttons: 2,
                  size: "lg",
                  lang: vue.lang.modal_Libraries,
                  funcNo: "",
                  funcYes: funcYes,

                };
               
                vue.$store.dispatch("showModalComponent", obj);
              })
            }

          },

        }

    }
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";

  .DeriveSearchedPartFormComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    td{
      word-break: break-all;
    }
    .input-group{
      min-width: 500px;

    }
    .select-group{
      min-width: 400px;

    }
    input-group-prepend{
      
      widows: 24px;
    }
    .img-thumbnail{
      width: 100px;
    }
    .red{
      color: $redfont;
    }
    .new-part{
      height: 31px !important;
      padding-left: 5px  !important;
    }
    .prepend-new-part{
      height: 31px;
    }
    .button_action_confirm{
      height: 31px;
    }
    .button_action_footprint{
      height: 31px;
    }
    .button_action_symbol{
      height: 31px;
    }
    .option-grey{
      color: #999;
    }
    .required{
      float: right;
      margin: 2px;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
    .new-part{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .select-prop-derive{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .input-group-append{
      margin-top: 3px;
      margin-bottom: 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DeriveSearchedPartFormComponent.vue